import { render } from "./ShowOrigin.vue?vue&type=template&id=393d651c"
import script from "./ShowOrigin.vue?vue&type=script&lang=js"
export * from "./ShowOrigin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/SQB/Projects/configurator-project/configurator/webapp/src/main/vue-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__